import React, {
  useEffect,
  useState
} from 'react';

import {
  useHistory,
  useLocation
} from 'react-router-dom';

import {
  SocialBundleProvider,
  SubscriptionProvisionProvider
} from 'journeys';

import {
  HandleRender,
  withScreenViewTagging
} from 'hocs';

import {
  BackButton
} from 'components';

import {
  VContainer,
  VContainerVH
} from '@vodacom/web-common';

import {
  Just4YouSocialBundleContainer,
  SocialBundleActivationContainer,
  SocialBundleMarketingBanner,
  SocialBundleStateContainer
} from '../components';

import {
  CustomColors
} from 'constants';

import {
  getStorageWithExpiry,
  handleUtagLinkEvent
} from 'helpers';

const SocialBundleUI = () => {

  const location = useLocation();
  const history = useHistory();

  const [ state, setState ] = useState({
    isBundleRedeemable: null,
    isBundleActivated: false,
    isTechnicalError: null,
    loading: true,
    isOnLandingPage: true,
    socialBundleType: location.state?.socialBundleType|| 'facebook',
    errorMessage: '',
    showJ4u: location.state?.showJ4u || false,
    vasList: location.state?.vasList || []
  });

  const getEligibility = async (socialMedia) => {

    const eligibilityResponse = await SocialBundleProvider.getEligibility(socialMedia);

    if (!eligibilityResponse?.ok || !eligibilityResponse?.result) {

      if (eligibilityResponse?.code === 406) {

        setState(prevState => ({
          ...prevState,
          errorMessage: eligibilityResponse?.error?.message,
          isBundleRedeemable: true,
          isTechnicalError: false,
          loading: false
        }));

        return;
      }

      setState(prevState => ({
        ...prevState,
        errorMessage: eligibilityResponse?.error?.message,
        isBundleRedeemable: true,
        isTechnicalError: true,
        loading: false
      }));

      return;
    }

    setState(prevState => ({
      ...prevState,
      isBundleRedeemable: eligibilityResponse.result?.setSocialBundleEligible,
      loading: false
    }));

  };

  const handleActivationStatus = async (soid) => {

    setState(prevState => ({
      ...prevState,
      loading: true
    }));

    if (state.errorMessage){

      setState(prevState => ({
        ...prevState,
        isOnLandingPage: false,
        loading: false
      }));

      return;
    }

    const flexActivationResponse = await SubscriptionProvisionProvider.provisionBundle(soid);

    if (!flexActivationResponse?.ok) {

      setState(prevState => ({
        ...prevState,
        isBundleActivated: false,
        isOnLandingPage: false,
        errorMessage: flexActivationResponse?.error?.message,
        loading: false
      }));

      return;
    }

    setState(prevState => ({
      ...prevState,
      isBundleActivated: true,
      isOnLandingPage: false,
      loading: false
    }));

  };

  const onHandleUtagLinkEvent = (link_id_descriptor = '') =>{

    handleUtagLinkEvent({
      event_name: 'campaign_internal_click',
      link_id: `cbu: connectu: facebook: ${link_id_descriptor}`
    });
  };

  useEffect(() => {

    if (state.isBundleRedeemable === null) {
      getEligibility(`${state.socialBundleType}-flex`);
    }
  }, []);

  return (
    <HandleRender
      isLoading={state.loading}
      isError={state.isTechnicalError}>
      { state.isOnLandingPage &&

        <BackButton
          margin={'8px 0px 0px 25px'}
          onClick={() => {
            onHandleUtagLinkEvent('back');
            history.goBack();
        }}/>
      }

      <VContainer
        margin={'24px 0px 0px 0px'}
        alignItems={'center'}>

        <VContainerVH
          borderRadius={'4px'}
          height={'auto'}
          minWidth={'320px'}
          width={'100%'}
          color={CustomColors.White}>

          { state.isOnLandingPage

            ? <>
                <SocialBundleMarketingBanner
                  socialBundleType={state.socialBundleType}/>

                <SocialBundleActivationContainer
                  socialBundleType={state.socialBundleType}
                  isBundleRedeemable={state.isBundleRedeemable}
                  onHandleUtagLinkEvent={onHandleUtagLinkEvent}
                  onActivationStatus={handleActivationStatus}/>

              </>

            :
              <SocialBundleStateContainer
                socialBundleType={state.socialBundleType}
                errorMessage={state.errorMessage}
                onHandleUtagLinkEvent={onHandleUtagLinkEvent}
                isBundleActivated = {state.isBundleActivated}/>
          }

          { state.showJ4u &&

            <Just4YouSocialBundleContainer
              vasList = {state.vasList}
              onHandleUtagLinkEvent={onHandleUtagLinkEvent}
              isBundleActivated = {state.isBundleActivated}/>
          }

        </VContainerVH>
      </VContainer>
    </HandleRender>
  );
};

SocialBundleUI.pageName = 'cbu: connectu: facebook: activate my free bundle';

SocialBundleUI.tagViewData = {
  page_section: 'facebook',
  visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
  visitor_type: 'consumer',
  visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
};

export const SocialBundle = withScreenViewTagging(SocialBundleUI);